import { createFileRoute } from '@tanstack/react-router'
import { StoreIcon } from 'lucide-react'

export const Route = createFileRoute('/_auth/_modules/_app/customers')({
  staticData: {
    title: 'route.customers',
    crumb: 'route.customers',
    icon: StoreIcon,
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
